import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboNivelGeneticoActivo`, method: 'GET', body: null, token: token})
}